import { SiteMapScreenshotsSchema } from './siteMapScreenshot'
import { z } from 'zod'
import { SIGHTMAP_DOC } from '../guidance/polish/sightmap/schema'

export const ProjectSightmapSchema = z.object({ doc: SIGHTMAP_DOC, screenshots: SiteMapScreenshotsSchema.default([]) })
export type ProjectSightmap = z.infer<typeof ProjectSightmapSchema>
